import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
  signal,
  WritableSignal,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LnFormContactComponent } from '@components/ln-form-contact/ln-form-contact.component';
import { LnPagesArmorComponent } from '@components/ln-pages-armor/ln-pages-armor.component';
import { LnArrowBackSvgIconComponent } from '@components/svg-icons/ln-arrow-back-svg-icon/ln-arrow-back-svg-icon.component';
import { PurchaseCompletionItemCardComponent } from '@components/cards/purchase-completion-item-card/purchase-completion-item-card.component';
import { ShoppingCartState } from '../../shared/states/shopping-cart-state';
import { UnsuccessfulOrderResponseCardComponent } from '@components/cards/unsuccessful-order-response-card/unsuccessful-order-response-card.component';
import { MenuActions } from '../../shared/states/menu_actions';
import { TranslocoPipe } from '@jsverse/transloco';
import { timer } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DeviceScreenFamilyService } from '@core/services/device-screen-family/device-screen-family.service';
import { ScrollService } from '@core/services/scroll/scroll.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'ln-ln-purchase-completion-form-page',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    LnPagesArmorComponent,
    LnArrowBackSvgIconComponent,
    CommonModule,
    ReactiveFormsModule,
    LnFormContactComponent,
    PurchaseCompletionItemCardComponent,
    UnsuccessfulOrderResponseCardComponent,
    TranslocoPipe,
  ],
  templateUrl: './ln-purchase-completion-form-page.component.html',
  styleUrls: ['./ln-purchase-completion-form-page.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnPurchaseCompletionFormPageComponent {
  private shoppingCartState = inject(ShoppingCartState);
  cardItems = computed(() => this.shoppingCartState.shoppingCartItems());
  protected showUnSuccessfulModal: WritableSignal<boolean> = signal(false);
  // protected showUnSuccessfulOrderCardTop: WritableSignal<boolean> = signal(true);
  protected showUnSuccessfulOrderCardBottom: WritableSignal<boolean> = signal(true);
  private menuActions = inject(MenuActions);
  private destroyRef = inject(DestroyRef);
  private deviceScreenFamily = inject(DeviceScreenFamilyService);
  protected currentScreenSize = this.deviceScreenFamily.currentDeviceScreenFamily;
  private scrollService = inject(ScrollService);
  protected imageUrl = environment.GOOGLE_STORAGE_URL + '/imagenes/' + environment.banners.PURCHASE_COMPLETION;
  protected presentUnSuccessfulModal() {
    this.showUnSuccessfulModal.set(true);
    // this.showUnSuccessfulOrderCardTop.set(true);
    this.showUnSuccessfulOrderCardBottom.set(true);
    if (this.currentScreenSize() === 'SM') {
      timer(1000)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.scrollToUnsuccessfulModal();
        });
    }
    this.closeUnSuccessfulModalAutomatically();
  }

  private closeUnSuccessfulModalAutomatically(): void {
    timer(5000)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        if (this.showUnSuccessfulModal() || this.showUnSuccessfulOrderCardBottom()) {
          this.showUnSuccessfulModal.set(false);
          this.showUnSuccessfulOrderCardBottom.set(false);
        }
      });
  }
  private scrollToUnsuccessfulModal() {
    this.scrollService.scrollToElementById('unSuccessfulOrder');
  }
  GoHome() {
    this.menuActions.navigateToShoppingCart();
  }
}
